module.exports = __webpack_public_path__ + "static/2-264033f5f62a25ee6456748b3fc99327.png";